import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import thunkMiddleware from 'redux-thunk';
import createLogger from 'redux-logger';

import globalReducer from 'reducers';

export const render = (view, reducer = globalReducer) => {
    const loggerMiddleware = createLogger();
    const store = createStore(reducer, window.INITIAL_STATE, applyMiddleware(thunkMiddleware, loggerMiddleware));
    ReactDOM.render(React.createElement(Provider, { store }, React.createElement(view, null, null)), document.getElementById('react-body'));
};



// WEBPACK FOOTER //
// ./src/views/client.js